import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import CommercialParticipantService from "@/views/sidebar/commercial-participant/participant.service";
import { 
  CommercialParticipantModel
} from "@/views/sidebar/commercial-participant/participant.types";

@Module({ namespaced: true })
class CommercialParticipant extends VuexModule {
  commercialParticipant: CommercialParticipantModel = new CommercialParticipantModel();

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchCommercialParticipant({ clientId, participantId }: { clientId: number, participantId: number }) {
    const commercialParticipant = await CommercialParticipantService.GetCommercialParticipant(clientId, participantId);
    this.context.commit("updateField", {
      path: "commercialParticipant",
      value: commercialParticipant
    });
  }

  @Action({ rawError: true })
  async UpsertParticipant(commercialParticipantModel: CommercialParticipantModel) {
    try {
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: null
      }, { root: true });
      await CommercialParticipantService.UpsertParticipant(commercialParticipantModel);
    } catch (e: any) {
      const errorMessage = e.response?.data || e.response.data.message || "An unexpected error occurred.";
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: errorMessage
      }, { root: true });
    }
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

CommercialParticipant.getters = { getField };
CommercialParticipant.mutations = { updateField };

export default CommercialParticipant;